export default __webpack_public_path__ + "static/media/Logo.639c463e.svg";